/* eslint-disable jsx-a11y/anchor-is-valid */
// i18next-extract-disable
import React from 'react';
import { Link, Box, Text, UnorderedList, ListItem } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { graphql, useStaticQuery } from 'gatsby';
import { Item } from '../Footer/data';
import Form from '../Form';

const FooterItem = ({ title, links }: Item): JSX.Element => {
  const { t } = useTranslation('footer');
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          formUrl
        }
      }
    }
  `);
  const { formUrl } = data.site.siteMetadata;

  return (
    <Box w="100%" mb={6}>
      <Text size="sm" color="gray.400" fontWeight="semibold" mb={4}>
        {t(title)}
      </Text>
      <UnorderedList spacing={3} style={{ listStyleType: 'none' }} m={0}>
        {links.map((link) => (
          <ListItem key={link.id}>
            {link.url || link.canToggleModal ? (
              <Link
                href={!link.canToggleModal ? link.url : undefined}
                onClick={() => (link.canToggleModal! ? toggleModal() : undefined)}
                className="hover:text-gray-400"
                isExternal
              >
                <Text size="md" color="white">
                  {t(link.id)}
                </Text>
              </Link>
            ) : (
              <Text size="md" color="white">
                {t(link.id)}
              </Text>
            )}
          </ListItem>
        ))}
      </UnorderedList>
      <Form isOpen={modalOpen} onClose={toggleModal} formUrl={formUrl} />
    </Box>
  );
};

export default FooterItem;
